module.exports = __webpack_public_path__ + "static/2-271610aa255d1306521004ae032af66c.jpeg";